import axios from './axiosInstance';
import { jsonToFormData } from "./converters";

export const actionsList = async (params = {}) => {
  const response = await axios.get("/club_api/actions", { params });
  return response.data;
};

export const actionDetails = async (id) => {
  const response = await axios.get("/club_api/actions/" + id );
  return response.data;
};

export const saveAction = async (action) => {
  const headers = { 'Content-Type': 'multipart/form-data' }
  const formData = jsonToFormData(action, "aktion")
  const response = !action?.id
    ? await axios.post("/club_api/actions/", formData, { headers } )
    : await axios.put("/club_api/actions/" + action.id, formData, { headers } );
  return response.data;
};


export const removeAction = async (id) => {
  const response = await axios.delete("/club_api/actions/" + id);
  return response.data;
};

export const getUploadUrl = async (filename) => {
  const response = await axios.get("/club_api/actions/upload_url", { params: { filename }} );
  return response.data;
};
